export default __webpack_public_path__ + "assets/images/2e82d7312b6735dbbbafa67094fbcbf4.png";